import {connect} from 'react-redux';
import {formValueSelector} from 'redux-form';
import VirtualEntryPaymentModal from './VirtualEntryPaymentModal.jsx';
import {
  handlePayBalanceOtherCancelClick,
  handlePaymentModalSubmitClick
} from './actions';

const selector = formValueSelector('adminVirtualEntryPaymentForm');

const mapStateToProps = state => ({
  paymentType: selector(state, 'paymentType'),
  amount: selector(state, 'amount'),
  visible: state.admin.virtualEventDetail.showPaymentModal,
  paymentModalType: state.admin.virtualEventDetail.paymentModalType,
  refundType: state.admin.virtualEventDetail.refundType,
  purchaseTransactions: state.admin.virtualEventDetail.creditPurchaseTransactions ? state.admin.virtualEventDetail.creditPurchaseTransactions : []
});

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch(handlePayBalanceOtherCancelClick()),
  onSubmit: data => dispatch(handlePaymentModalSubmitClick(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(VirtualEntryPaymentModal);



// WEBPACK FOOTER //
// ./src/features/admin/virtualEventDetail/VirtualEntryPaymentModalContainer.jsx